/**
 * Side-effect module: index.tsx imports it FIRST, before amplifyConfig and
 * App. Imports evaluate in order, so a module that throws while the bundle is
 * still initialising (a blank app, the 2026-09-25 failure class) already has a
 * listener to report it.
 */

import { installClientErrorFlush } from "./client-error-reporter";
import { installGlobalErrorHandlers } from "./flow-telemetry";

// Registers pagehide/visibilitychange listeners so queued browser errors are
// flushed before the tab closes. Without this, the most useful reports (user
// gives up on a broken page and leaves) are lost with the tab.
installClientErrorFlush();
installGlobalErrorHandlers();
